<template>
    <div class="micro-app-box">
        <iframe
            ref="iframeEle"
            name="tmsOrder"
            :src="url"
            iframe
            frameborder="0"
        ></iframe>
    </div>
</template>
<script>
import config from '@/config/user.env';

export default {
    name: 'orderManageTaskDetail',
    data () {
        let baseURL = ''
        if (config.env === 'PROD') {
            baseURL = 'https://an.annto.com/otp.html#/order-manage/task-detail?iframeLSP&readonly=true&';
        } else if (config.env === 'VER') {
            baseURL = 'https://an-ver.annto.com/otp.html#/order-manage/task-detail?iframeLSP&readonly=true&';
        } else {
            baseURL = 'https://an-uat.annto.com/otp.html#/order-manage/task-detail?iframeLSP&readonly=true&';
        }
        return {
            config,
            storeInfo: {},
            baseURL,
        };
    },
    computed: {
        url () {
            return this.baseURL + `taskNo=${this.$route.query.taskNo}`
        }
    }
};
</script>
<style lang="less">
.micro-app-box {
    width: 100%;
    height: 100%;
    iframe{
        width: 100%;
        height:calc(100vh - 45px);
    }
}
</style>
